<main class="page">
  <ng-content></ng-content>
</main>
